module.exports = __webpack_public_path__ + "static/media/benefit-stress.ce17c6f4.svg";